import { useQuery } from '@apollo/client';
import { days } from 'react-awesome-calendar-ts';

import { Days } from 'common/utils';
import GET_HOLIDAYS from './holidays.gql';

const useHolidays = (months: Days[]) => {
  const startDate = ((months && months[0]) || days()).startOf('year');
  const endDate = startDate.add(1, 'year').endOf('month');
  const { data } = useQuery(GET_HOLIDAYS, {
    variables: {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    fetchPolicy: 'cache-first',
  });
  const holidays = data?.holidays || [];
  return holidays;
};

export default useHolidays;
